// ABOUTME: Per-feeling SVG face path data (brows/eyes/mouth), ported verbatim from the prototype's
// ABOUTME: hand-authored F/coreHue objects (Crossing Prototype v25.dc.html:4315-4322) (Issue #1945).

export interface FeelingFacePaths {
  brows: string;
  eyeSleepy: string;
  eyeFull: string;
  mouth: string;
  mouthFull: string;
  extra: string;
}

export const FEELING_FACES: Record<string, FeelingFacePaths> = {
  happy: {
    brows: 'M19 22 Q23.5 20 28 22 M36 22 Q40.5 20 45 22',
    eyeSleepy: 'M21 31 Q24.5 27.5 28 31 M36 31 Q39.5 27.5 43 31',
    eyeFull: '',
    mouth: 'M23 41 Q32 47 41 41',
    mouthFull: '',
    extra: '',
  },
  excited: {
    brows: 'M18 20.5 Q23 17.5 28 19.5 M36 19.5 Q41 17.5 46 20.5',
    eyeSleepy: '',
    eyeFull: 'M24.5 27 a3 3 0 1 0 0.01 0 M39.5 27 a3 3 0 1 0 0.01 0',
    mouth: '',
    mouthFull: 'M24 40.5 Q32 49.5 40 40.5 Q32 44.5 24 40.5 Z',
    extra: '',
  },
  surprised: {
    brows: 'M19 18.5 Q23.5 16.5 28 18.5 M36 18.5 Q40.5 16.5 45 18.5',
    eyeSleepy: '',
    eyeFull: 'M24.5 26.8 a3.1 3.1 0 1 0 0.01 0 M39.5 26.8 a3.1 3.1 0 1 0 0.01 0',
    mouth: 'M32 37.5 a4 4.8 0 1 0 0.01 0',
    mouthFull: '',
    extra: '',
  },
  scared: {
    brows: 'M19 21 Q23 18 27 19 M45 21 Q41 18 37 19',
    eyeSleepy: '',
    eyeFull: 'M24 26 a3.8 3.8 0 1 0 0.01 0 M40 26 a3.8 3.8 0 1 0 0.01 0',
    mouth: 'M32 38.5 a3.2 4.2 0 1 0 0.01 0',
    mouthFull: '',
    extra: '',
  },
  sad: {
    brows: 'M19 25 L28 22 M45 25 L36 22',
    eyeSleepy: 'M21 32 Q24.5 34.5 28 32 M36 32 Q39.5 34.5 43 32',
    eyeFull: '',
    mouth: 'M24 45 Q32 40.5 40 45',
    mouthFull: '',
    extra: '',
  },
  worried: {
    brows: 'M19 23.5 L27 20.5 M45 23.5 L37 20.5',
    eyeSleepy: '',
    eyeFull: 'M23.5 27.6 a2.7 2.7 0 1 0 0.01 0 M38.5 27.6 a2.7 2.7 0 1 0 0.01 0',
    mouth: 'M25 43.5 Q31 41.3 37 43.5 Q38.5 44 40 43.3',
    mouthFull: '',
    extra: '',
  },
  yucky: {
    brows: 'M19 22 Q23 19.5 27 21 M37 24.5 L45 26.5',
    eyeSleepy: 'M20 30.5 L27 31 M36 30.5 Q39.5 28 43 30.5',
    eyeFull: '',
    mouth: 'M24 43.5 Q28 41 32 43.5 Q36 46 40 43.5',
    mouthFull: '',
    extra: 'M29.5 35 L33 34 M29.5 38 L33 37',
  },
  angry: {
    brows: 'M18 22 L28 26 M46 22 L36 26',
    eyeSleepy: 'M21 31.5 L28 31.5 M36 31.5 L43 31.5',
    eyeFull: '',
    mouth: 'M23 43 Q32 45 41 43',
    mouthFull: '',
    extra: '',
  },
};
